import { ReactElement } from "jsx-dom";
import { Icon } from "./Icon";

export const Pill = ({ text }: { text: string | ReactElement }) => {
  return (
    <p class="tw:bg-fruugo-off-white tw:border-2 tw:border-fruugo-dark-grey tw:py-2 tw:px-4 tw:rounded-full tw:m-auto tw:inline-flex tw:justify-center tw:items-center">
      <Icon name="page-info" className="small tw:mr-2" />
      {text}
    </p>
  );
};
